import { echartLine } from '../common';

export function echartVieLineMonth(vis, datos) {
  echartLine(
    datos,
    true,
    1,
    'VIES PRINCIPALS DE LA CIUTAT: HISTÒRIC MENSUAL',
    'Vehicles',
    'chartViesLineMonth',
    'no_dataViesLineMonth',
    undefined,
    true,
  );
}
